<!-- 免去登录，直接授权 -->
<template>
  <div></div>
</template>

<script>
// import DataTransformUtils from "@/utils/DataTransformUtils";
let Base64 = require('js-base64').Base64;
// import CommonApi from '@/api/CommonApi'
export default {
  data() {
    return {
      info: {},
      loginResponse: {}
    }
  },
  async created() {

    // eyJhY2Nlc3NfdG9rZW4iOiIwNWNlZjE5MS1iNTZmLTRjNGEtYmQxNC05MzFkZWQ5MmUyYzEiLCJ0b2tlbl90eXBlIjoiYmVhcmVyIiwicmVmcmVzaF90b2tlbiI6IjM1NWMwNmJjLTMzNTgtNDNjNC04MDc1LTM0YTIwOGY5NmJjOSIsImV4cGlyZXNfaW4iOjk5OTk5LCJ0ZW5hbnRPcmdJZCI6ImFkYTZjZTUzNWI5YmVhODdhMGVmN2ZhOTZiYmM1ZTI3IiwidGVuYW50SWQiOiIwMjdkMzcwMzBmMDc4ZGQyMGRjZWQxYTQ1YWJjMDQwZiIsInVzZXJJZCI6ImE0ZWE2NDk4MjdmMzBhOGFiMDdjMGI1NzRhNmI0OTE0Iiwic2NvcGUiOiJhcHAiLCJ0eXBlIjowfQ%3D%3D
    this.info = JSON.parse(Base64.decode(this.$route.query.data));
    console.log('info', this.info);

    this.$store.commit(
      'SET_AUTHORIZATION',
      this.info.token_type + ' ' + this.info.access_token
    )


    this.$store.commit(
      'SET_USERINFO',this.info
    )
    this.$router.push({ name: 'home' })

    // commit(
    //                     'SET_AUTHORIZATION',
    //                     _data.token_type + _data.access_token
    //                 )
    //                 commit('SET_USERINFO', _data)



    // this.loginResponse = await CommonApi.getUserDetail({
    //   params: {
    //     id: this.info.userId
    //   }
    // })
    // console.log('this.loginResponse', this.loginResponse);
    // if (this.loginResponse.code == 200) {
    //   // 基本信息
    //   this.$store.commit('SET_USERINFO', this.loginResponse.data)
    // }
    // sessionStorage.setItem('isBack',true)
    // console.log(document.referrer)
    // console.log(">>>>>>>>>>>>>>>>>>>")
    // if(document.referrer.includes("https://paas.tsingning.com")){
    //   sessionStorage.setItem('isBack',true)
    // }else{
    //   sessionStorage.setItem('isBack','')
    // }

    // location.href = window.location.origin + "/smartsite/workbench/index";

    //   CommonApi.getMyMenuPlatforms().then((res) => {
    //     if (res.code == 200) {
    //       let arr = res.data.map((item) => ({
    //         value: item.id,
    //         name: item.name,
    //         parent: item.parentId || "",
    //         parents: item.parentIds || "",
    //         type: item.type,
    //         targetUrl: item.targetUrl,
    //         icon: item.icon,
    //         description: item.description,
    //         permissionCode: item.permissionCode,
    //         platformDescribes: item.platformDescribes,
    //         systemGroupName: item.systemGroupName,
    //       }));
    //       let treeArr = DataTransformUtils.toTree(
    //         arr,
    //         "value",
    //         "parent",
    //         "children"
    //       );
    //       this.treeArr = treeArr;
    //       console.log(this.treeArr)
    //       treeArr.map((item)=>{
    //         item.children.map((items)=>{
    //           if(items.targetUrl=='/worksite/pcms/labour/person/list'&&this.$route.query.type==1){//人员车辆管理系统
    //             localStorage.setItem("navList", JSON.stringify(item.children));
    //             location.href = window.location.origin + "/smartsite/worksite/pcms/labour/person/list";
    //           }else if(items.targetUrl=='/worksite/mdms/device'&&this.$route.query.type==2){//机器设备管理系统
    //             localStorage.setItem("navList", JSON.stringify(item.children));
    //             location.href = window.location.origin + "/smartsite/worksite/mdms/device";
    //           }else if(items.targetUrl=='/worksite/mms/purchase/list'&&this.$route.query.type==3){//材料管理系统
    //             localStorage.setItem("navList", JSON.stringify(item.children));
    //             location.href = window.location.origin + "/smartsite/worksite/mms/purchase/list";
    //           }else if(items.targetUrl=='/worksite/spms/broadcast'&&this.$route.query.type==4){//法规宣导系统
    //             localStorage.setItem("navList", JSON.stringify(item.children));
    //             location.href = window.location.origin + "/smartsite/worksite/spms/broadcast";
    //           }
    //           else if(this.$route.query.type==5){//环境监测系统
    //             localStorage.setItem("navList", JSON.stringify(item.children));
    //             location.href = window.location.origin + "/smartsite/bigscreen/environment";
    //           }
    //           else if(items.targetUrl=='/quality/qa/works'&&this.$route.query.type==6){//质量系统
    //             localStorage.setItem("navList", JSON.stringify(item.children));
    //             location.href = window.location.origin + "/smartsite/quality/qa/works";
    //           }
    //           else if(items.targetUrl=='/progress'&&this.$route.query.type==7){//计划系统
    //             // localStorage.setItem("navList", JSON.stringify(item.children));
    //             location.href = window.location.origin + "/smartsite/progress/schedule-manage";
    //           }
    //           else if(items.targetUrl=='/worksite/collision-alarm/alarm-event'&&this.$route.query.type==14){//预警事件
    //             localStorage.setItem("navList", JSON.stringify(item.children));
    //             location.href = window.location.origin + "/smartsite/worksite/collision-alarm/alarm-event";
    //           }else if(this.$route.query.type==13){//可视化bim大屏
    //             location.href = window.location.origin + "/smartsite/bigscreen/visual-bigscreen?mapLevel=2&nodeType=2";
    //           }
    //           else if(this.$route.query.type==12){//数字化工地大屏
    //             location.href = window.location.origin + "/smartsite/bigscreen/visual-bigscreen?mapLevel=2&nodeType=1";
    //           }
    //           else if(this.$route.query.type==15){//AR云上工地
    //             location.href = window.location.origin + "/smartsite/bigscreen/cloud-worksite";
    //           }
    //           else if(this.$route.query.type==16){//工作台
    //             location.href = window.location.origin + "/smartsite/workbench/index";
    //           }

    //           else if(this.$route.query.type==9){//数值化安全监管平台
    //             location.href = window.location.origin + "/smartsite/bigscreen/worksite-safety";
    //           }
    //           else if(this.$route.query.type==11){//数字化工程管理平台
    //             location.href = window.location.origin + "/smartsite/bigscreen/visual-bigscreen";
    //           }
    //         })
    //       })

    //         // localStorage.setItem("navList", JSON.stringify(this.result[i].allData));
    //         // location.href = window.location.origin + "/smartsite" + item.targetUrl;

    //         // window.location.origin + "/smartsite/worksite/pcms/labour/person/list";


    //     }
    //   });




    // if(this.$route.query.type==1){
    //   location.href =
    //       window.location.origin + "/smartsite/worksite/pcms/labour/person/list";
    // }else if(this.$route.query.type==2){
    //     location.href =
    //       window.location.origin + "/smartsite/worksite/mdms/device";
    // }else if(this.$route.query.type==3){
    //     location.href =
    //       window.location.origin + "/smartsite/worksite/mms/purchase/list";
    // }else if(this.$route.query.type==4){
    //     location.href =
    //       window.location.origin + "/smartsite/worksite/spms/broadcast";
    // }else if(this.$route.query.type==5){
    //     location.href =
    //       window.location.origin + "/smartsite/worksite/environmental/index";
    // }else if(this.$route.query.type==6){
    //     location.href =
    //       window.location.origin + "/smartsite/quality/qa/works";
    // }
    // else if(this.$route.query.type==7){
    //     location.href =
    //       window.location.origin + "/smartsite/progress/schedule-manage";
    // }
    // else if(this.$route.query.type==14){
    //     location.href =
    //       window.location.origin + "/smartsite/worksite/collision-alarm/alarm-event";
    // }else if(this.$route.query.type==13){
    //     location.href =
    //       window.location.origin + "/smartsite/bigscreen/bim-visual";
    // }else if(this.$route.query.type==12){
    //     location.href =
    //       window.location.origin + "/smartsite/worksite/monitor/index";
    // }else if(this.$route.query.type==15){
    //     location.href =
    //       window.location.origin + "/smartsite/bigscreen/cloud-worksite";
    // }else if(this.$route.query.type==16){
    //     location.href =
    //       window.location.origin + "/smartsite/workbench/indexs";
    // }else if(this.$route.query.type==11){
    //     location.href =
    //       window.location.origin + "/smartsite/bigscreen/engineering-business";
    // }
    // else if(this.$route.query.type==9){
    //     location.href =
    //       window.location.origin + "/smartsite/bigscreen/worksite-safety";
    // }
  },
}
</script>
<style scoped>
</style>